<template>
    <div class="ec2" v-loading="loading" element-loading-text="拼命加载中">
        <el-scrollbar height="calc(100vh - 120px)">
            <div class="tableSelect" ref="tableSelect" style="margin-bottom:0;">
                <el-form :inline="true" :model="formInline" label-position="left">
                    <el-form-item label="月份">
                        <el-date-picker 
                            style="width:120px;"
                            @change="search"
                            format="YYYY-MM"
                            value-format="YYYYMM"
                            v-model="formInline.month"
                            type="month"
                            placeholder="选择月">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="地区">
                        <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in regionList"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Payers" v-if="curRole!='customer'">
                        <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in payersList"
                                :key="index"
                                :label="item.name+'('+item.payer_id+')'"
                                :value="item.payer_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售" v-if="curRole=='admin'">
                        <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                            <el-option
                                v-for="item in salesList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="伙伴" v-if="curRole=='admin'||curRole=='sales'">
                        <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                            <el-option
                                v-for="item in agentsList"
                                :key="item.agent_id"
                                :label="item.company"
                                :value="item.agent_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户" v-if="curRole!='customer'">
                        <el-select v-model="formInline.company_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in customersList"
                                :key="index"
                                :label="item.company"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="ec2data">
                    <el-row class="boxRow">
                        <el-col :span="7" v-if="ec2Data && ec2Data.EC2 && ec2Data.ec2list && ec2Data.ec2list.length >= 2">
                            <el-row class="ec2Cost">
                                <el-card :class="curRole!='customer'?'h160':'h314'">
                                    <div class="title">EC2费用</div>
                                    <div class="cost">
                                        <div class="left">
                                            <p>{{ ec2Data.ec2list[ec2Data.ec2list.length - 2].month }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(ec2Data.ec2list[ec2Data.ec2list.length - 2].total).toFixed(2) }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(ec2Data.ec2list[ec2Data.ec2list.length - 2].usage).toFixed(2) }}</p>
                                        </div>
                                        <div class="left">
                                            <p>{{ ec2Data.EC2.month }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(ec2Data.EC2.total).toFixed(2) }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(ec2Data.EC2.usage).toFixed(2) }}</p>
                                        </div>
                                    </div>
                                    <div class="percent">
                                        <div style="font-size:30px;" v-if="Number(ec2Data.ec2list[ec2Data.ec2list.length - 2].total)!=Number(ec2Data.EC2.total)">
                                            {{ percentage(ec2Data.ec2list[ec2Data.ec2list.length - 2].total,ec2Data.EC2.total) }}
                                            <img :src="Number(ec2Data.ec2list[ec2Data.ec2list.length - 2].total)>Number(ec2Data.EC2.total)?require('../../assets/img/down.png'):require('../../assets/img/up.png')" alt="">
                                        </div>
                                        <div style="font-size:30px;" v-else>NA</div>
                                    </div>
                                </el-card>
                            </el-row>
                            <el-row v-if="curRole!='customer'">
                                <el-col :span="6">
                                    <el-card class="h80">
                                        <div class="title">积分</div>
                                        <div class="num">{{formInline.region=='cn'?'￥':'$'}}{{ Number(ec2Data.EC2.credit).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="6">
                                    <el-card class="h80">
                                        <div class="title">SP抵扣</div>
                                        <div class="num">{{formInline.region=='cn'?'￥':'$'}}{{ Number(ec2Data.EC2.sp).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="6">
                                    <el-card class="h80">
                                        <div class="title">RI抵扣</div>
                                        <div class="num">{{formInline.region=='cn'?'￥':'$'}}{{ Number(ec2Data.EC2.rifee).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="6">
                                    <el-card class="h80">
                                        <div class="title">税</div>
                                        <div class="num">{{formInline.region=='cn'?'￥':'$'}}{{ Number(ec2Data.EC2.tax).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="5" v-if="ec2Data">
                            <el-row>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">实例数量</div>
                                        <div class="num1">{{ Number(ec2Data.EC2.instanceCount) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">EBS数量</div>
                                        <div class="num1">{{ Number(ec2Data.EC2.ebsCount) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">区域数量</div>
                                        <div class="num1">{{ Number(ec2Data.EC2.regionCount) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">快照数量</div>
                                        <div class="num1">{{ Number(ec2Data.EC2.snapshotCount) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-card class="">
                                <div class="title" style="font-size:18px;">EC2-Computer费用详情</div>
                                <div id="chart1" class="chart"></div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">EC2-Instances</div>
                            <el-table stripe :data="instanceList" ref="tableref" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="实例ID" prop="resId" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="型号" prop="type"></el-table-column>
                                <el-table-column label="系统详情">
                                    <template #default="scope">
                                        {{ scope.row.os +'/'+ scope.row.cpu +'c/'+ scope.row.mem }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="CPU型号" prop="cpufeatures" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="使用时长" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="实例成本" prop="onDemandCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.onDemandCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="付费模型" prop="pricingTerm" align="right"></el-table-column>
                                <el-table-column label="节省" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ (Number(scope.row.onDemandCost) - Number(scope.row.unblendedCost)).toFixed(2) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                        </el-card>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">EC2-Volumn</div>
                            <el-table stripe :data="storageList" ref="tableref1" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="ID" prop="resId" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="型号" prop="type"></el-table-column>
                                <el-table-column label="容量" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="费用" prop="unblendedCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.unblendedCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
                        </el-card>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">EC2-快照</div>
                            <el-table stripe :data="snapshotList" ref="tableref2" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="ID" prop="resId" :show-overflow-tooltip="true">
                                    <template #default="scope">{{ scope.row.resId.split('/')[1] }}</template>
                                </el-table-column>
                                <el-table-column label="型号" prop="type"></el-table-column>
                                <el-table-column label="容量" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="快照费" prop="unblendedCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.unblendedCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm2" @callFather="callFather2"></Pagination>
                        </el-card>
                    </el-row>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {getEC2Data,getEC2Details,getSalesList,getAgentList,getCustomerList,getPayerList} from '@/api/api'
    import * as echarts from 'echarts';
    import Pagination from "@/components/Pagination";
    export default{
        name:'ec2Summary',
        components:{
            Pagination
        },
        data(){
            return{
                agentsList:[],
                payersList:[],
                customersList:[],
                salesList:[],
                formInline:{
                    month:0,
                    region:'cn',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    company_id:''
                },
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'} 
                ],
                loading:false,
                ec2Data:null,
                instanceParams:{
                    type:'instance',
                    page:1,
                    limit:20
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                instanceList:[],
                storageParams:{
                    type:'storage',
                    page:1,
                    limit:20
                },
                pageparm1: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                storageList:[],
                snapshotParams:{
                    type:'snapshot',
                    page:1,
                    limit:20
                },
                pageparm2: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                snapshotList:[],
                curRole:localStorage.getItem('curRole'),
            }
        },
        created(){
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取上一个月
            let endM = (date.getMonth() < 10 ? '0' + (date.getMonth() ) : date.getMonth());
            this.formInline.month = endY+endM;
            if(this.curRole=='agent'||this.curRole=='customer'){
                this.formInline.region='global'
            }
            this.getPermissionList();
        },
        methods:{
            async getPermissionList(){
                this.loading = true;
                if(this.curRole!='customer'){
                    await this.getPayersList();
                    await this.getAgentsList();
                }
                if(this.curRole=='admin'||this.curRole=='sales'){
                    await this.getSaleList();
                }
                await this.getCustomersList();
                await this.search()
                this.loading = false;
            },
            //获取列表
            async search() {
                this.loading = true;
                try {
                await getEC2Data(this.formInline).then(res => {
                    if(res.code ==2000) {
                        this.ec2Data = res.data;
                        this.ec2Data.EC2.usage = Number(this.ec2Data.EC2.usage).toFixed(2);
                        this.ec2Data.EC2.tax = Number(this.ec2Data.EC2.tax).toFixed(2);
                        this.ec2Data.EC2.credit = Number(this.ec2Data.EC2.credit).toFixed(2);
                        this.ec2Data.EC2.rifee = Number(this.ec2Data.EC2.rifee).toFixed(2);
                        this.ec2Data.EC2.sp = Number(this.ec2Data.EC2.sp).toFixed(2);
                        this.ec2Data.EC2.others = Number(this.ec2Data.EC2.others).toFixed(2);
                        this.ec2Data.EC2.total = 
                            (Number(this.ec2Data.EC2.usage)+
                            Number(this.ec2Data.EC2.tax)+
                            Number(this.ec2Data.EC2.credit)+
                            Number(this.ec2Data.EC2.sp)+
                            Number(this.ec2Data.EC2.rifee)).toFixed(2);
                        var xData=[],yData={
                            usage:[],
                            rifee:[],
                            sp:[],
                            credit:[],
                            tax:[],
                            others:[]
                        };
                        this.ec2Data.ec2list.forEach(el=>{
                            el.usage = Number(el.usage).toFixed(2);
                            el.tax = Number(el.tax).toFixed(2);
                            el.credit = Number(el.credit).toFixed(2);
                            el.rifee = Number(el.rifee).toFixed(2);
                            el.sp = Number(el.sp).toFixed(2);
                            el.others = Number(el.others).toFixed(2);
                            el.total = (Number(el.usage)+
                                        Number(el.tax)+
                                        Number(el.credit)+
                                        Number(el.sp)+
                                        Number(el.rifee)).toFixed(2);
                            xData.push(el.month);
                            yData.usage.push(el.usage);
                            yData.rifee.push(el.rifee);
                            yData.sp.push(el.sp);
                            yData.credit.push(el.credit);
                            yData.tax.push(el.tax);
                            yData.others.push(el.others);
                        })
                        this.$nextTick(()=>{
                            this.loadLineChart(document.getElementById('chart1'),xData,yData)
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
                await this.getDetails(1)
                await this.getDetails(2)
                await this.getDetails(3)
                } finally {
                    this.loading = false;
                }
            },
            async getDetails(type){
                var data={};
                if(type==1){
                    data = Object.assign({},this.formInline,this.instanceParams);
                }else if(type == 2){
                    data = Object.assign({},this.formInline,this.storageParams);
                }else{
                    data = Object.assign({},this.formInline,this.snapshotParams);
                }
                await getEC2Details(data).then(res=>{
                    if(res.code==2000){
                        if(type==1){
                            this.instanceList = res.data;
                            this.pageparm.page = res.page;
                            this.pageparm.limit = res.limit;
                            this.pageparm.total = res.total;
                        }else if(type==2){
                            this.storageList = res.data;
                            this.pageparm1.page = res.page;
                            this.pageparm1.limit = res.limit;
                            this.pageparm1.total = res.total;
                        }else{
                            this.snapshotList = res.data;
                            this.pageparm2.page = res.page;
                            this.pageparm2.limit = res.limit;
                            this.pageparm2.total = res.total;
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            callFather(parm) {
                this.instanceParams.page = parm.page
                this.instanceParams.limit = parm.limit
                this.getDetails(1)
            },
            callFather1(parm) {
                this.storageParams.page = parm.page
                this.storageParams.limit = parm.limit
                this.getDetails(2)
            },
            callFather2(parm) {
                this.snapshotParams.page = parm.page
                this.snapshotParams.limit = parm.limit
                this.getDetails(3)
            },
            // 获取伙伴列表
            async getAgentsList(){
                await getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 获取销售列表
            async getSaleList(){
                await getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取客户列表
            async getCustomersList(){
                await getCustomerList({company:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.customersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取payer列表
            async getPayersList(){
                await getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 计算两个值的percent,num1为上月费用，num2为当月费用
            percentage(num1,num2){
                var numA = Number(num1).toFixed(2);
                var numB = Number(num2).toFixed(2);
                let upOrDown = '', percent = '';
                if (Number(numA) < Number(numB)) {
                    upOrDown = '+';
                    percent = Math.abs((((Number(numB) - Number(numA)) / Number(numA))*100).toFixed(2)) + '%';
                } else if (Number(numA) > Number(numB)) {
                    upOrDown = '-';
                    percent = Math.abs((((Number(numA) - Number(numB)) / Number(numA))*100).toFixed(2)) + '%';
                }
                return `${upOrDown}${percent}`
            },

            loadLineChart(dom,xData,yData){
                var myChart = echarts.getInstanceByDom(dom) || echarts.init(dom);
                var option,_this = this;
                option = {
                    tooltip: {
                        trigger: 'axis',
                        valueFormatter:function(value){
                            if(_this.formInline.region=='cn'){
                                return '￥'+value
                            }else{
                                return '$'+value
                            }
                        }
                    },
                    legend: {
                        data: ['Usage', 'RIFee', 'SP抵扣', '积分', 'Tax','Other']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'Usage',
                            type: 'line',
                            stack: 'Total',
                            data: yData.usage
                        },
                        {
                            name: 'RIFee',
                            type: 'line',
                            stack: 'Total',
                            data: yData.rifee
                        },
                        {
                            name: 'SP抵扣',
                            type: 'line',
                            stack: 'Total',
                            data: yData.sp
                        },
                        {
                            name: '积分',
                            type: 'line',
                            stack: 'Total',
                            data: yData.credit
                        },
                        {
                            name: 'Tax',
                            type: 'line',
                            stack: 'Total',
                            data: yData.tax
                        },
                        {
                            name: 'Other',
                            type: 'line',
                            stack: 'Total',
                            data: yData.others
                        }
                    ]
                };
                option && myChart.setOption(option);
            },
        },
    }
</script>
<style lang="scss">
    .ec2{
        height: calc(100vh - 120px);
        overflow-y: auto;
        background: #f5f7fa;
        padding: 24px;
        position: relative;
        .tableSelect {
            background: #ffffff;
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            border: 1px solid #e4e7ed;
            transition: all 0.3s ease;
            
            &:hover {
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
            }
            
            .el-form {
                display: flex;
                flex-wrap: wrap;
                gap: 20px;
                align-items: end;
                
                .el-form-item {
                    margin-bottom: 0;
                    margin-right: 0;
                    
                    .el-form-item__label {
                        font-weight: 500;
                        color: #606266;
                        font-size: 14px;
                        margin-bottom: 8px;
                        line-height: 1.4;
                    }
                    
                    .el-form-item__content {
                        margin-left: 0 !important;
                    }
                    
                    .el-select, .el-date-picker {
                        min-width: 140px;
                        
                        .el-input__wrapper {
                            border-radius: 6px;
                            background: #ffffff;
                            border: 1px solid #dcdfe6;
                            transition: all 0.3s ease;
                            height: 36px;
                            
                            &:hover {
                                border-color: #c0c4cc;
                            }
                            
                            &.is-focus {
                                border-color: #409eff;
                                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                            }
                            
                            .el-input__inner {
                                font-size: 14px;
                                color: #606266;
                                background: transparent;
                                
                                &::placeholder {
                                    color: #c0c4cc;
                                }
                            }
                        }
                    }
                }
            }
        }

        .ec2data{
            margin-top: 0;
        }
        .el-loading-spinner{
            top:300px;
        }
        .el-card.h240{
            height:240px;
        }
        .el-card.h160{
            height:212px;
        }
        .el-card.h314{
            height:314px;
            .cost{
                margin-top:70px;
            }
        }
        .el-card.h120{
            height:156px;
            .el-card__body .title{
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                border-left: 4px solid #409eff;
                margin-bottom: 16px;
                padding-left: 12px;
                line-height: 1.5;
            }
        }
        .el-card.h80{
            height: 140px;
            
            .el-card__body {
                padding: 12px 8px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
                text-align: center;
                
                .title{
                    font-size: 12px;
                    font-weight: 600;
                    color: #303133;
                    border-left: 3px solid #409eff;
                    margin-bottom: 12px;
                    padding-left: 6px;
                    line-height: 1.2;
                    white-space: nowrap;
                    width: 100%;
                    text-align: left;
                }
                
                .num {
                    font-size: 18px;
                    font-weight: 600;
                    color: #409eff;
                    margin: 0;
                    white-space: nowrap;
                }
            }
        }
        .el-card {
            border: 1px solid #e4e7ed;
            border-radius: 8px;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
            margin: 0 12px 16px 12px;
            
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
            }
        }

        .el-card__body{
            position: relative;
            padding: 20px;
            
            .title{
                font-size: 16px;
                font-weight: 600;
                color: #303133;
                border-left: 4px solid #409eff;
                margin-bottom: 16px;
                padding-left: 12px;
                line-height: 1.5;
            }
            .cost{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 12px;
                
                .left{
                    text-align: center;
                    flex: 1;
                    
                    p{
                        font-size: 24px;
                        margin-top: 12px;
                        font-weight: 600;
                        color: #303133;
                        margin-bottom: 6px;
                    }
                    p:first-child{
                        font-size: 14px;
                        margin-top: 0;
                        font-weight: 500;
                        color: #909399;
                        margin-bottom: 12px;
                    }
                    p:last-child{
                        color: #909399;
                        font-weight: 400;
                        text-decoration: line-through;
                        font-size: 16px;
                    }
                }
            }
            .percent{
                position: absolute;
                left: 50%;
                bottom: 16px;
                transform: translate(-50%, 0);
                font-size: 16px;
                font-weight: 600;
                color: #67c23a;
                display: flex;
                align-items: center;
                gap: 6px;
                
                img{
                    width: 14px;
                    height: 14px;
                }
            }
            .num{
                font-size: 26px;
                text-align: center;
                line-height: 36px;
                font-weight: 600;
                color: #409eff;
                margin-top: 12px;
            }
            .num1{
                font-size: 36px;
                text-align: center;
                line-height: 80px;
                font-weight: 700;
                color: #409eff;
            }
        }
        .boxRow{
            display: flex;
            margin: 20px 0;
            
            .el-col{
                .ec2Cost{
                    display: block;
                }
            }
            .cont{
                width: calc(100% - 24px);
                background: #ffffff;
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                padding: 24px;
                margin: 0 12px;
                border: 1px solid #e2e8f0;
                transition: all 0.2s ease;
                
                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
                }
                
                .title{
                    font-size: 16px;
                    font-weight: 600;
                    color: #374151;
                    border-left: 4px solid #3b82f6;
                    margin-bottom: 20px;
                    padding-left: 12px;
                }
            }
            .chart{
                width: 100%;
                height: 280px;
                border-radius: 8px;
                overflow: hidden;
            }
            .chart2{
                height: 380px;
            }
            .chart3{
                height: 520px;
            }
        }
        .tableRow{
            display: block;
            margin-top: 20px;
            
            .lyPagination-page{
                box-shadow: none;
                border: none;
            }
            .el-card__body{
                padding-bottom: 0;
            }
        }
        
        // Table styling
        .el-table {
            border-radius: 8px;
            overflow: hidden;
            background: #ffffff;
            border: 1px solid #e4e7ed;
            
            .el-table__header {
                th {
                    background: #f5f7fa;
                    color: #909399;
                    font-weight: 600;
                    border-bottom: 1px solid #e4e7ed;
                    font-size: 14px;
                    padding: 12px;
                }
            }
            
            .el-table__body {
                tr {
                    transition: all 0.3s ease;
                    
                    &:hover {
                        background: #f5f7fa !important;
                    }
                    
                    td {
                        border-bottom: 1px solid #f0f2f5;
                        color: #606266;
                        font-size: 14px;
                        padding: 12px;
                        
                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }
                
                tr:last-child td {
                    border-bottom: none;
                }
            }
        }
        
        // Scrollbar styling
        .el-scrollbar__bar {
            &.is-vertical {
                .el-scrollbar__thumb {
                    background: #c0c4cc;
                    border-radius: 4px;
                    
                    &:hover {
                        background: #909399;
                    }
                }
            }
        }
    }

    // Responsive design
    @media (max-width: 1200px) {
        .ec2 {
            .boxRow {
                .el-col {
                    margin-bottom: 16px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .ec2 {
            padding: 16px;
            
            .tableSelect {
                padding: 16px;
                margin-bottom: 16px;
                
                .el-form {
                    gap: 16px;
                    
                    .el-form-item {
                        .el-form-item__label {
                            font-size: 13px;
                            margin-bottom: 6px;
                        }
                        
                        .el-select, .el-date-picker {
                            min-width: 120px;
                            
                            .el-input__wrapper {
                                height: 32px;
                            }
                        }
                    }
                }
            }
            
            .boxRow {
                margin: 16px 0;
            }
            
            .el-card {
                margin: 0 4px 12px 4px;
                
                .el-card__body {
                    padding: 16px;
                    
                    .title {
                        font-size: 14px;
                        margin-bottom: 12px;
                        padding-left: 10px;
                    }
                    
                    .cost .left p {
                        &:not(:first-child) {
                            font-size: 20px;
                        }
                        &:last-child {
                            font-size: 14px;
                        }
                    }
                    
                    .num {
                        font-size: 22px;
                        line-height: 32px;
                    }
                    
                    .num1 {
                        font-size: 28px;
                        line-height: 60px;
                    }
                }
            }
            
            .tableRow {
                margin-top: 16px;
            }
        }
    }
</style>